// extracted by mini-css-extract-plugin
export var details = "_du-0";
export var inspectorPopover = "_du-1";